const setDropdownText = (checkedCount, text) => {
    const mobile = window.matchMedia("(max-width: 1024px)");
    if (!checkedCount > 0) {
        return text;
    } else {
        if (mobile.matches) {
            return "Selection";
        } else {
            return text;
        }
    }
};
const handleDropdownClose = () => {
    const dropdowns = document.querySelectorAll(".c-filters__dropdown-title");
    dropdowns.forEach((dropdown) => {
        dropdown.setAttribute('data-title', dropdown.innerText);
        dropdown.addEventListener("click", (e) => {
            dropdowns.forEach((item) => {
                item.parentElement !== e.target.parentElement &&
                item.parentElement.classList.contains("dropdown-list-focus")
                    ? item.parentElement.classList.remove("dropdown-list-focus")
                    : null;
            });
            const parent = e.target.parentElement;
            if (parent.classList.contains("dropdown-list-focus")) {
                parent.classList.remove("dropdown-list-focus");
            } else {
                parent.classList.add("dropdown-list-focus");
            }

            e.stopPropagation();
        });
    });
};

const handleDropdown = async (type, selector) => {
    const mobile = window.matchMedia("(max-width: 1024px)");
    let defText = mobile.matches ? "Selection" : type;
    const targets = document.querySelectorAll(selector);
    targets.forEach((target) => {
        let dropdownElement = target.parentElement.parentElement.querySelector(
            ".c-filters__dropdown-title"
        );
        if (target.classList.contains("geography") && mobile.matches) {
            defText = "Region";
        }
        dropdownElement.innerText = setDropdownText(0, defText);

        const checkboxes = target.querySelectorAll("input[type=checkbox]");
        const selectedCheckboxes = [];
        checkboxes.forEach((checkbox) => {
            let dropdownElement =
                target.parentElement.parentElement.querySelector(
                    ".c-filters__dropdown-title"
                );
            dropdownElement.innerText = setDropdownText(0, defText);
            checkbox.addEventListener("change", (e) => {
                const parent = e.target.closest("li");
                const selectTitle = e.target
                    .closest(".c-filters__dropdown-select")
                    .querySelector(".c-filters__dropdown-title");
                const mobileTitle = e.target
                    .closest(".c-filters__dropdown-select")
                    .getAttribute("data-title");

                const width = window.innerWidth;
                if (e.target.checked) {
                    parent.classList.add("dropdownActive");
                    !selectedCheckboxes.includes(e.target) &&
                        selectedCheckboxes.push(e.target);
                } else {
                    parent.classList.remove("dropdownActive");
                    selectedCheckboxes.pop(e.target);
                }
                if (selectedCheckboxes.length > 0) {
                    if (width < 1200) {
                        selectTitle.innerText = `${selectedCheckboxes.length} selected`;
                        selectTitle
                            .closest(".c-filters__dropdown-select")
                            .classList.add("dropdownActive");
                    }
                } else {
                    if (width > 1200) {
                        selectTitle.innerText = mobileTitle;
                    } else {
                        selectTitle.innerText = "Selection";
                        selectTitle
                            .closest(".c-filters__dropdown-select")
                            .classList.remove("dropdownActive");
                    }
                }
            });
        });
    });
    const observerCallback = () => {
        const width = window.innerWidth;
        const activeFacets = document.querySelectorAll(".active-facets span");
        targets.forEach((target) => {
            const checkboxes = target.querySelectorAll("input[type=checkbox]");
            if (activeFacets.length) {
                activeFacets.forEach((facet) => {
                    const facetName = facet.innerText;
                    if (facetName.includes("Insight")) {
                        facet.classList.add("hidden");
                    }
                    for (let i = 0; i < checkboxes.length; i++) {
                        if (
                            checkboxes[i].nextElementSibling instanceof
                                HTMLLabelElement &&
                            facetName.toLowerCase() ===
                                checkboxes[
                                    i
                                ].nextElementSibling.innerText.toLowerCase()
                        ) {
                            checkboxes[i].checked = true;
                            checkboxes[i].dispatchEvent(new Event("change"));
                            checkboxes[i]
                                .closest("li")
                                .classList.add("dropdownActive");
                        }
                    }
                });
            }
        });
        let insightContainer =
            document.querySelector(".insights-facet") || null;
        let activeFacetsContainer = document.querySelector(".active-facets");
        let hasInsights = false;
        for (let i = 0; i < activeFacets.length; i++) {
            if (activeFacets[i].getAttribute("name").includes("Insight")) {
                hasInsights = true;
                break;
            } else {
                hasInsights = false;
            }
        }
        if (width < 1200 && !insightContainer && hasInsights) {
            let insightDiv = document.createElement("div");
            insightDiv.classList.add("insights-facet");
            activeFacets.forEach((facet) => {
                if (facet.getAttribute("name").includes("Insight")) {
                    insightDiv.appendChild(facet);
                }
            });
            activeFacetsContainer.appendChild(insightDiv);
        } else if (width < 1200 && insightContainer && hasInsights === false) {
            insightContainer.remove();
        }
        return;
    };
    const targetNode = document.querySelector(".active-facets") || null;
    const config = {
        childList: true,
        subtree: true,
    };
    const mObserver = new MutationObserver(observerCallback);
    targetNode && mObserver.observe(targetNode, config);
};
export const countAppliedFilters = async () => {
    const targets = document.querySelectorAll(".c-filters");
    let targetsArray = [...targets];
    let activeFacets = [];

    targetsArray.forEach((target) => {
        const facetsContainer = target?.querySelector(".active-facets");
        if (facetsContainer) {
            setAppliedFiltersCounter(target, facetsContainer);
            const observer = new MutationObserver((mutationsList) => {
                mutationsList.forEach((mutation) => {
                    if (mutation.type === "childList" || mutation.type === "subtree") {
                        const facets = facetsContainer.querySelectorAll("span");
                        activeFacets.length = 0; // Clear previous entries
                        facets.forEach((element) => {
                            activeFacets.push(element.innerText);
                            element.tabIndex = 0;
                            element.addEventListener("keypress", (e) => {
                                if (e.key === "Enter") {
                                    element.click();
                                }
                            });
                        });
                        setAppliedFiltersCounter(target, facetsContainer);
                    }
                });
            });
            observer.observe(facetsContainer, { childList: true, subtree: true });
        }
    });
};
window.dateInputsFilled = 0;
const setAppliedFiltersCounter = (target, facetsContainer) => {
    try {
        let activeFiltersCount = target.querySelector(
            ".c-filters__button--results"
        );
        activeFiltersCount.innerText =
            facetsContainer.childElementCount + window.dateInputsFilled;
    } catch {
        console.log(facetsContainer.childElementCount);
    }
};

const datePickerContainers = document.querySelectorAll(
    ".date-picker-container"
);
datePickerContainers.forEach((item) => {
    const observer = new MutationObserver(() => {
        let dateInputsFilled = document.querySelectorAll(
            ".date-filled-static"
        ).length;
        window.dateInputsFilled = dateInputsFilled;
        countAppliedFilters();
    });
    observer.observe(item, { attributes: true, childList: true });
});
window.addEventListener("DOMContentLoaded", () => {
    countAppliedFilters();
    handleDropdownClose();
});

export const handleEndMarketDropdown = () => {
    handleDropdown("End markets", ".key-markets");
};

export const handleGeographyDropdown = () => {
    handleDropdown("Geography", ".geography");
};

//let activeFiltersCount = activeFilters.closest('.c-filters__button--results')
//console.log(activeFilters.closest('.c-filters__button--results'))
//activeFiltersCount.innerText = activeFilters.parentElement.childElementCount
